import React, { useState } from 'react'
import TextField from '../../../../Components/GeneralComponents/TextField'
import AuthForm from '../AuthForm'
import { ButtonOutline } from '../../../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import { validateBothPasswords } from '../../../../Helpers/passwordValidations'
import successToast from '../../../../Components/Toasts/SuccessToast'
import errorToast from '../../../../Components/Toasts/ErrorToast'
import PropTypes from 'prop-types'
import { getAuth, updatePassword } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import { app_sso } from '../../../../firebase'

function ResetPasswordForm() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  })

  const handleChange = event => {
    const { name, value } = event.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async event => {
    event.preventDefault()
    const { password, confirmPassword } = formData

    const { error: passwordError } = validateBothPasswords(
      password,
      confirmPassword
    )
    if (passwordError) {
      errorToast(passwordError)
      return
    }

    try {
      const auth = getAuth(app_sso)
      const user = auth.currentUser
      if (!user) throw new Error('User not authenticated')

      await updatePassword(user, password)
      successToast('Password changed successfully!')
      navigate('/login')
    } catch (error) {
      console.error(error)
      errorToast(error.message || 'Something went wrong')
    }
  }

  return (
    <AuthForm title={'Reset Login Credentials'} onSubmit={handleSubmit}>
      <TextField
        label={'Password'}
        placeholder={'Enter password'}
        onChange={handleChange}
        value={formData.password}
        name="password"
        id="password"
        type="password"
      />

      <TextField
        label={'Confirm Password'}
        placeholder={'Enter password'}
        onChange={handleChange}
        value={formData.confirmPassword}
        name="confirmPassword"
        id="confirmPassword"
        type="password"
      />

      <ButtonOutline type="submit" color="pink" text="Continue" />
    </AuthForm>
  )
}

ResetPasswordForm.propTypes = {
  oobCode: PropTypes.string,
}

export default ResetPasswordForm
